<template>
  <div>
    <div class="modal fade" id="modal-precinto_individual">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Precinto Individual</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              id="close-modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label>Número De Precinto</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="num_precinto"
                  placeholder="Número Precinto"
                  v-model="form.numero"
                  :class="$v.form.numero.$invalid ? 'is-invalid' : 'is-valid'"
                />
              </div>
              <div class="form-group col-md-12">
                <label>Estado</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.estado"
                  :class="$v.form.estado.$invalid ? 'is-invalid' : 'is-valid'"
                  disabled
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="estado in $parent.listasForms.estados"
                    :key="estado.numeracion"
                    :value="estado.numeracion"
                  >
                    {{ estado.descripcion }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="save()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PrecintoIndividual",
  components: {},
  data() {
    return {
      form: {
        numero: null,
        estado: 1,
      },
    };
  },
  validations: {
    form: {
      numero: {
        required,
      },
      estado: {
        required,
      },
    },
  },
  methods: {
    resetForm() {
      this.form = {
        numero: null,
        estado: 1,
      };
    },
    save() {
      // Validar que el número de precinto no esté vacío
      if (!this.form.numero || this.form.numero.toString().trim() === '') {
        this.$swal({
          icon: "warning",
          title: "Por favor ingrese el número de precinto",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      this.$parent.cargando = true;
      axios
        .post("/api/argentina/precintos/individual", this.form)
        .then(async (response) => {
          this.$parent.cargando = false;
          this.$refs.closeModal.click();
          await this.$parent.getIndex();
          await this.$parent.getGrafica();
          this.resetForm();
          this.$swal({
            icon: "success",
            title: response.data.msg || "El precinto se creó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$parent.cargando = false;
          let res = Object.assign({}, e);
          let errorMsg = "Ocurrió un error, vuelva a intentarlo...";
          
          // Manejar errores de validación
          if (res.response?.data?.errors) {
            const errors = Object.values(res.response.data.errors).flat();
            errorMsg = errors.join(', ');
          } else if (res.response?.data?.msg) {
            errorMsg = res.response.data.msg;
          } else if (res.response?.data?.message) {
            errorMsg = res.response.data.message;
          }
          
          this.$swal({
            icon: "error",
            title: errorMsg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
  },
};
</script>
